/**
 * Use EventBus.$emit() and EventBus.$on() to send and listen to events across the app
 */
import Vue from 'vue'
export const EventBus = new Vue()
